import {
  Button,
  FileUpload,
  SelectDropDown,
  TextField,
} from '@/components/Common';
import {
  IconPosition,
  TextfieldType,
} from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import file from '@/assets/icons/file.svg';
import graduationCap from '@/assets/icons/graduation.svg';
import uiwDate from '@/assets/icons/uiw_date.svg';
import { FieldError } from 'react-hook-form';
import { Calendar } from '@/components/Common/Calendar/Calendar';
import { useEpreuve } from '@/pages/Epreuve/Epreuve.hook';
import { useExamStore } from '@/store/ExamStore/ExamStore';

export const EpreuveForm = () => {
  const {
    handleSubmit,
    register,
    errors,
    setValue,
    onSubmit,
    isCreatingExam,
    disciplines,
    generateUrlLoading,
  } = useEpreuve();
  const { setIsOpenExamModal, isOpenExamModal } = useExamStore();

  return (
    <Modal
      isOpen={isOpenExamModal}
      onClose={() => setIsOpenExamModal(false)}
      modalStyle="bg-bgModal"
      headerStyle="bg-bgModal h-[36px]"
    >
      <div className="w-[375px]">
        <div className="flex flex-col justify-center items-center mb-5">
          <h1 className="text-primary text-xl font-bold">Ajouter L’épreuve</h1>
          <h5 className="text-xs pt-0 mt-0 text-[#9FA9B2]">
            Information sur l’épreuve
          </h5>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="max-w-[308px] mx-auto"
        >
          <div className="flex flex-col gap-y-1">
            <TextField
              className="mb-0 placeholder:text-iconColor placeholder:text-sm ml-3"
              borderStyle="!bg-almostBlack pl-[12px]"
              register={register('name')}
              placeholder="Intitulé"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={file} alt="file" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.name?.message}
              errorStyle="!text-red-500"
            />

            <SelectDropDown
              selectDropDownStyle={{
                borderRadius: '0.375rem',
                color: '#fff',
                padding: ' 0.5rem',
              }}
              className="placeholder:text-iconColor placeholder:text-sm ml-3"
              placeholder="Discipline"
              name="discipline"
              setValue={setValue}
              icon={<img src={graduationCap} alt="graduationCap" />}
              helpText={(errors.discipline as FieldError)?.message}
              errorStyle="text-red-500"
              options={disciplines || []}
            />
            <Calendar
              name="year"
              label="Année"
              view="year"
              dateFormat="yy"
              setValue={setValue}
              helpText={errors.year?.message}
              errorStyle="text-red-500 text-xs"
              dateIcon={uiwDate}
              showIcon={true}
              maxDate={new Date()}
              className="bg-[#232323] text-sm text-[#949494] font-normal"
            />
            <FileUpload
              id={`epreuve-picture`}
              placeholder="Fichier épreuve"
              name="content"
              disabled={false}
              setValue={setValue}
              helpText={errors.content?.message}
              errorStyle="!text-red-500"
              icon={<img src={file} alt="file" />}
              fileUploadStyle="!bg-almostBlack text-lg pl-3 pr-1"
              allowedFileTypes={['image/png', 'image/jpeg', 'image/jpg']}
            />
          </div>
          <div className="w-full flex justify-center items-center mt-14">
            <Button
              type="submit"
              title={
                isCreatingExam || generateUrlLoading
                  ? 'Ajout en cours...'
                  : 'Ajouter'
              }
              className="w-full"
              disabled={isCreatingExam || generateUrlLoading}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};
